var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('h6',[_vm._v("Invalid Action, please contact your Administrator")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }